import { isNullish } from "@client/common/js/helpers/typeHelpers";

const tabNumberMap = { all: 0, products: 1, pages: 2, documentsandvideos: 3, brandproducts: 4 } as const;

export type SearchTab = keyof typeof tabNumberMap;

export function isSearchTab(x: unknown): x is SearchTab {
	return Object.hasOwn(tabNumberMap, x as PropertyKey);
}

export function getSearchTabNumber(tabName: SearchTab | undefined): (typeof tabNumberMap)[SearchTab] {
	return isNullish(tabName) ? 0 : tabNumberMap[tabName];
}
